import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import OffCanvas from "../../../OffCanvas/OffCanvas";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import ButtonIcon from "../../../Buttons/ButtonIcon";
import { FaRegEdit } from "react-icons/fa";
import EditRegistrationForm from "./EditRegistrationForm";
import PrivacyDisclaimerText from "../../../Common/EventRegistration/PrivacyDisclaimerText";

const ViewRegistrationForm = ({ formContent, token, eventID }) => {
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(""); // ← Add state for phone number

  const toggleEditForm = () => {
    setIsOffcanvasOpen(!isOffcanvasOpen);
  };

  const formatLabel = (label, name) => {
    if (label && label !== name) {
      return label;
    }
    if (name) {
      return name
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    }
    return label || name || '';
  };

  const customFields = formContent[0]?.customFields || [];

  return (
    <React.Fragment>
      <div className="w-100 mt-3 mt-md-4 mb-3 d-flex justify-content-center px-2 px-md-0">
        <div
          style={{
            width: "100%",
            maxWidth: "900px",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            margin: "0 auto",
          }}
          className="registration-form-container"
        >
          <div className="d-flex justify-content-end mx-1 mx-md-2 mb-2 mb-md-3">
            <ButtonIcon
              Title="Edit Form"
              BackgroundColor="#F68A20"
              ColorText="white"
              BorderColor="#F68A20"
              borderRadius={25}
              handleOnclick={toggleEditForm}
              Icon={<FaRegEdit size={15} color="white" />}
            />
          </div>
          
          <div className="w-100 px-2 px-md-4 mb-2 mt-2">
            <form noValidate autoComplete="off" data-testid="form">
              <Row className="g-3">
                {customFields.slice(0, 4).map((field, index) => {
                  const displayLabel = formatLabel(field?.label, field?.name);
                  return (
                    <Col xs={12} md={6} key={field._id || field.id || index}>
                      <div className="w-100 mb-2">
                        <label 
                          className="form-label"
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            marginBottom: "6px",
                            display: "block",
                            color: "#495057",
                          }}
                        >
                          {displayLabel}
                          {field.required && <span className="text-danger">*</span>}
                        </label>
                        {field.question_type === "email" ? (
                          <input
                            name={field.name}
                            type="email"
                            className="form-control form-control-lg"
                            placeholder={displayLabel}
                            style={{
                              fontSize: "16px",
                              padding: "12px 16px",
                              minHeight: "48px",
                              borderRadius: "8px",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#fff",
                            }}
                          />
                        ) : field.name === "phoneNumber" ? (
                          <div 
                            className="phone-input-container"
                            style={{
                              width: "100%",
                              position: "relative",
                            }}
                          >
                            <PhoneInput
                              international
                              countryCallingCodeEditable={false}
                              defaultCountry="ZA"
                              value={phoneNumber} // ← Bind to state
                              onChange={setPhoneNumber} // ← Update state on change
                              className="custom-phone-input"
                              inputComponent={({ className, onChange, value, ...rest }) => (
                                <input
                                  className={`${className} form-control form-control-lg`}
                                  onChange={onChange}
                                  value={value}
                                  style={{
                                    fontSize: "16px",
                                    padding: "12px 16px 12px 52px",
                                    minHeight: "48px",
                                    width: "100%",
                                    boxSizing: "border-box",
                                    borderRadius: "8px",
                                    border: "1px solid #dee2e6",
                                    backgroundColor: "#fff",
                                  }}
                                  {...rest}
                                />
                              )}
                            />
                          </div>
                        ) : (
                          <input
                            name={field.name}
                            type="text"
                            className="form-control form-control-lg"
                            placeholder={displayLabel}
                            style={{
                              fontSize: "16px",
                              padding: "12px 16px",
                              minHeight: "48px",
                              borderRadius: "8px",
                              border: "1px solid #dee2e6",
                              backgroundColor: "#fff",
                            }}
                          />
                        )}
                      </div>
                    </Col>
                  );
                })}
                
                {customFields.slice(4).map((field) => {
                  const displayLabel = formatLabel(field?.label, field?.name);
                  return (
                    <Col xs={12} key={field._id}>
                      <div className="mb-3">
                        {field.question_type === "text" && (
                          <div className="mb-2">
                            <label 
                              className="form-label"
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                marginBottom: "6px",
                                display: "block",
                                color: "#495057",
                              }}
                            >
                              {displayLabel}
                              {field.required && <span className="text-danger">*</span>}
                            </label>
                            <input
                              type="text"
                              className="w-100 form-control form-control-lg"
                              placeholder={displayLabel}
                              name={field.name}
                              style={{
                                fontSize: "16px",
                                padding: "12px 16px",
                                minHeight: "48px",
                                borderRadius: "8px",
                                border: "1px solid #dee2e6",
                                backgroundColor: "#fff",
                              }}
                            />
                          </div>
                        )}
                        {field.question_type === "short_answer" && (
                          <div className="mb-2">
                            <label 
                              className="form-label"
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                marginBottom: "6px",
                                display: "block",
                                color: "#495057",
                              }}
                            >
                              {displayLabel}
                              {field.required && <span className="text-danger">*</span>}
                            </label>
                            <input
                              type="text"
                              className="w-100 form-control form-control-lg"
                              placeholder={displayLabel}
                              name={field.name}
                              style={{
                                fontSize: "16px",
                                padding: "12px 16px",
                                minHeight: "48px",
                                borderRadius: "8px",
                                border: "1px solid #dee2e6",
                                backgroundColor: "#fff",
                              }}
                            />
                          </div>
                        )}
                        {field.question_type === "paragraph" && (
                          <div className="mb-2">
                            <label 
                              className="form-label"
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                marginBottom: "6px",
                                display: "block",
                                color: "#495057",
                              }}
                            >
                              {displayLabel}
                              {field.required && <span className="text-danger">*</span>}
                            </label>
                            <textarea
                              rows={5}
                              className="form-control"
                              placeholder={displayLabel}
                              name={field.name}
                              style={{
                                fontSize: "16px",
                                padding: "12px 16px",
                                minHeight: "120px",
                                borderRadius: "8px",
                                border: "1px solid #dee2e6",
                                backgroundColor: "#fff",
                              }}
                            />
                          </div>
                        )}
                        {field.question_type === "options" && (
                          <div className="mb-2">
                            <label 
                              className="form-label"
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                marginBottom: "6px",
                                display: "block",
                                color: "#495057",
                              }}
                            >
                              {displayLabel}
                              {field.required && <span className="text-danger">*</span>}
                            </label>
                            <div className="w-100" style={{ maxWidth: "100%" }}>
                              <select
                                className="px-2 form-control form-control-lg"
                                name={field.name}
                                style={{
                                  fontSize: "16px",
                                  padding: "12px 16px",
                                  minHeight: "48px",
                                  width: "100%",
                                  borderRadius: "8px",
                                  border: "1px solid #dee2e6",
                                  backgroundColor: "#fff",
                                  cursor: "pointer",
                                }}
                              >
                                <option value="">Select...</option>
                                {field.list.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}
                        {field.question_type === "checkbox" && (
                          <div className="mb-2">
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#495057",
                                margin: 0,
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                name={field.name}
                                style={{ width: "18px", height: "18px" }}
                              />
                              {displayLabel}
                              {field.required && <span className="text-danger">*</span>}
                            </label>
                          </div>
                        )}
                        {field.question_type === "privacy_disclaimer" && (
                          <div className="mb-2">
                            <PrivacyDisclaimerText linkUrl={field.linkUrl} />
                          </div>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </form>
          </div>
        </div>
      </div>

      <OffCanvas
        isOffcanvasOpen={isOffcanvasOpen}
        title="Update Registration form"
        body={
          <EditRegistrationForm
            token={token}
            eventID={eventID}
            setIsOffcanvasOpen={setIsOffcanvasOpen}
            dataForm={customFields}
            formID={formContent[0]?._id}
          />
        }
        toggleSaveChanges={toggleEditForm}
        directionOffCanvas="end"
        widthOffCanvas="100%"
      />

      <style>{`
        /* Phone Input Container */
        .phone-input-container {
          width: 100%;
          position: relative;
        }
        
        .custom-phone-input {
          width: 100%;
        }
        
        .custom-phone-input .PhoneInput {
          display: flex;
          width: 100%;
          align-items: center;
          border: 1px solid #dee2e6 !important;
          border-radius: 8px !important;
          background-color: #fff !important;
          min-height: 48px !important;
          position: relative;
        }
        
        .custom-phone-input .PhoneInputCountry {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px;
          z-index: 2;
          background: transparent;
          border: none;
          border-radius: 4px;
        }
        
        .custom-phone-input .PhoneInputCountryIcon {
          width: 24px;
          height: 16px;
          box-shadow: 0 0 0 1px #dee2e6;
          background-color: white;
          border-radius: 4px;
          overflow: hidden;
          display: inline-block;
          position: relative;
        }
        
        .custom-phone-input .PhoneInputCountryIcon img,
        .custom-phone-input .PhoneInputCountryIcon svg {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        
        .custom-phone-input .PhoneInputCountrySelect {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          opacity: 0;
          cursor: pointer;
          z-index: 3;
        }
        
        .custom-phone-input .PhoneInputCountrySelectArrow {
          display: none !important;
        }
        
        .custom-phone-input .PhoneInputInput {
          flex: 1;
          padding: 12px 16px 12px 52px !important;
          font-size: 16px;
          min-height: 48px;
          border: none !important;
          border-radius: 8px;
          box-sizing: border-box;
          width: 100%;
          background-color: transparent;
          color: #495057;
        }
        
        .custom-phone-input .PhoneInputInput:focus {
          outline: none;
        }
        
        .custom-phone-input .PhoneInputInput::placeholder {
          color: #adb5bd;
        }
        
        /* Form Controls */
        .form-control,
        .form-control-lg,
        input[type="text"],
        input[type="email"],
        select,
        textarea {
          font-size: 16px !important;
          padding: 12px 16px !important;
          min-height: 48px !important;
          border-radius: 8px !important;
          border: 1px solid #dee2e6 !important;
          background-color: #fff !important;
          color: #495057 !important;
          transition: all 0.2s ease !important;
        }
        
        .form-control:focus,
        .form-control-lg:focus,
        input[type="text"]:focus,
        input[type="email"]:focus,
        select:focus,
        textarea:focus {
          border-color: #F68A20 !important;
          box-shadow: 0 0 0 3px rgba(246, 138, 32, 0.15) !important;
          outline: none !important;
        }
        
        .form-control::placeholder,
        input[type="text"]::placeholder,
        input[type="email"]::placeholder,
        textarea::placeholder {
          color: #adb5bd !important;
        }
        
        .form-label {
          font-size: 14px !important;
          font-weight: 500 !important;
          margin-bottom: 6px !important;
          color: #495057 !important;
        }
        
        /* Responsive */
        @media (min-width: 769px) {
          .custom-phone-input .PhoneInputCountry {
            left: 12px;
          }
          
          .custom-phone-input .PhoneInputInput {
            padding: 12px 16px 12px 52px !important;
          }
          
          .custom-phone-input .PhoneInputCountryIcon {
            width: 24px;
            height: 16px;
          }
        }
        
        @media (max-width: 768px) {
          .registration-form-container {
            padding: 15px !important;
            border-radius: 8px !important;
            margin: 0 8px !important;
          }
          
          .custom-phone-input .PhoneInputCountry {
            left: 10px;
          }
          
          .custom-phone-input .PhoneInputCountryIcon {
            width: 20px;
            height: 14px;
          }
          
          .custom-phone-input .PhoneInputInput {
            padding: 12px 14px 12px 45px !important;
            font-size: 16px !important;
          }
          
          .form-control,
          .form-control-lg,
          input[type="text"],
          input[type="email"],
          select,
          textarea {
            font-size: 16px !important;
            padding: 12px 14px !important;
          }
          
          .g-3 > * {
            padding-right: 8px !important;
            padding-left: 8px !important;
          }
        }
        
        @media (max-width: 576px) {
          .registration-form-container {
            padding: 12px !important;
          }
          
          .custom-phone-input .PhoneInputCountryIcon {
            width: 18px;
            height: 12px;
          }
          
          .custom-phone-input .PhoneInputInput {
            padding: 12px 12px 12px 42px !important;
          }
        }
        
        button {
          min-height: 44px;
          min-width: 44px;
        }
        
        .mb-2 {
          margin-bottom: 0.5rem !important;
        }
        
        .mb-3 {
          margin-bottom: 1rem !important;
        }
      `}</style>
    </React.Fragment>
  );
};

export default ViewRegistrationForm;